import { useLocation } from 'react-router';

export default function useQueryUrl(key: string) {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const param = searchParams.get(key);
    return param;
}
